module.exports = __webpack_public_path__ + "static/media/DO_HIEN.b3d716a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/TestimonialsCarousel/assets/DO_HIEN.jpg
// module id = 1117
// module chunks = 0